import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import { Pages, SampleCardTitle, SamplePageTitle } from "../../../Constants/Constants";
import { SamplePageSubTitle } from "../../../Data/Pages/Pages";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SamplePageContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={SamplePageTitle} parent={Pages} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SampleCardTitle} span={SamplePageSubTitle} tag />
              <CardBody>
                <P>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</P>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SamplePageContainer;
